<template>
    <div>
        <div
            v-for="option in visibilityOptions"
            :key="option.id"
            class="cabinet-form-group"
        >
            <label class="custom-radio">
                <input
                    v-model="visibilityVal"
                    type="radio"
                    name="visibility"
                    :value="option.id"
                />
                <span class="custom-radio__checkmark"></span>
                {{ option.title }}
            </label>
            <div
                class="product-form-visibility__descr"
                v-html="option.descr"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductVisibility',
    props: {
        visibility: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            visibilityOptions: [
                {
                    id: 0,
                    title: 'Не видно никому',
                    descr:
                        ' Изделие не видно ни одному ритейлеру.<br>Подписавшиеся на ваш бренд ритейлеры не получают оповещение о регистрации новинки. <br> Изделие не отображается розничным покупателям.'
                },
                {
                    id: 2,
                    title: 'Видно всем',
                    descr:
                        'Изделие видно всем ритейлерам.<br>Все подписавшиеся на ваш бренд ритейлеры получают оповещение о регистрации новинки.  <br> Изделие отображается розничным покупателям.'
                },
                {
                    id: 1,
                    title: 'Ограниченный доступ',
                    descr:
                        'Изделие видно только ритейлерам, которым вы дали доступ.<br>Ритейлеры с доступом получают оповещение о регистрации новинки.  <br>Изделие не отображается розничным покупателям.'
                }
            ]
        }
    },
    computed: {
        visibilityVal: {
            get() {
                return this.visibility
            },
            set(val) {
                this.$emit('onChange', val)
            }
        }
    }
}
</script>
